/**
 * Collection Filter & Sort AJAX v2 — UnaLuka
 * Compatible: Android 5+ WebView, Samsung Internet, in-app browsers
 * Sin ES6: no const/let, no arrow, no optional chaining, no template literals
 */
(function () {
  "use strict";

  function getParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name) || "";
  }

  function qsa(el, sel) {
    var nodes = el.querySelectorAll(sel);
    var arr = [];
    for (var i = 0; i < nodes.length; i++) arr.push(nodes[i]);
    return arr;
  }

  function init(container) {
    var formFilter = container.querySelector("#collection-filters-form") || container.querySelector("#search-filters-form");
    var productGrid = container.querySelector(".main-collection-product-grid");
    var sidebarContainer = container.querySelector("#main-collection-filters");
    var paginationContainers = qsa(container, ".pagination-container");

    if (!productGrid) return;

    initMaxlist(container);

    /* ═══ Filter: checkbox change ═══ */
    if (formFilter) {
      qsa(formFilter, ".filter-group-display__list-item_checkbox").forEach(function (el) {
        el.addEventListener("change", function () { updateFilter(); });
      });

      qsa(formFilter, ".filter-group-display__submit input").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          updateFilter();
        });
      });
    }

    /* ═══ Sort: desktop dropdown ═══ */
    var sortBox = container.querySelector("#sort_by_box");
    var sortName = container.querySelector(".sort-by .name");
    if (sortBox) {
      qsa(sortBox, ".sort-action").forEach(function (item) {
        item.addEventListener("click", function (e) {
          e.preventDefault();
          if (this.classList.contains("active")) return;
          var sortValue = this.getAttribute("data-sort");
          updateSort(sortValue);
          qsa(sortBox, ".sort-action").forEach(function (i) { i.classList.remove("active"); });
          this.classList.add("active");
          var aEl = this.querySelector("a");
          if (sortName && aEl) sortName.innerHTML = aEl.innerHTML;
        });
      });
    }

    /* ═══ Mobile: filter button ═══ */
    var mobFilterBtn = container.querySelector(".unl-mob-filter");
    if (mobFilterBtn) {
      mobFilterBtn.addEventListener("click", function () {
        document.body.classList.add("sidebar-opened");
        if (typeof AT_Main !== "undefined" && AT_Main.fixNoScroll) AT_Main.fixNoScroll();
      });
    }

    /* Legacy mobile filter icon */
    var mobileFilterIcon = container.querySelector(".mobile-filter-icon");
    if (mobileFilterIcon) {
      mobileFilterIcon.addEventListener("click", function () {
        document.body.classList.add("sidebar-opened");
        if (typeof AT_Main !== "undefined" && AT_Main.fixNoScroll) AT_Main.fixNoScroll();
      });
    }

    /* Close sidebar */
    var jsSidebarClose = container.querySelector(".js-sidebar-close");
    if (jsSidebarClose) {
      jsSidebarClose.addEventListener("click", closeSidebar);
    }

    function closeSidebar() {
      document.body.classList.remove("sidebar-opened");
      if (typeof AT_Main !== "undefined" && AT_Main.fixReturnScroll) AT_Main.fixReturnScroll();
    }

    /* ═══ Mobile: sort bottom sheet ═══ */
    var sortSheet = document.getElementById("unl-sort-sheet");
    var mobSortBtn = container.querySelector(".unl-mob-sort");

    if (sortSheet && mobSortBtn) {
      mobSortBtn.addEventListener("click", function () {
        var currentSort = getParam("sort_by") || "manual";
        qsa(sortSheet, ".unl-sort-options li").forEach(function (li) {
          if (li.getAttribute("data-sort") === currentSort) {
            li.classList.add("active");
          } else {
            li.classList.remove("active");
          }
        });
        sortSheet.classList.add("open");
        document.documentElement.classList.add("overflow-hidden");
      });

      var overlay = sortSheet.querySelector(".unl-sort-overlay");
      var closeBtn = sortSheet.querySelector(".unl-sort-close");
      if (overlay) overlay.addEventListener("click", closeSortSheet);
      if (closeBtn) closeBtn.addEventListener("click", closeSortSheet);

      qsa(sortSheet, ".unl-sort-options li").forEach(function (li) {
        li.addEventListener("click", function () {
          var sortValue = this.getAttribute("data-sort");
          updateSort(sortValue);

          if (sortBox) {
            qsa(sortBox, ".sort-action").forEach(function (i) { i.classList.remove("active"); });
            var match = sortBox.querySelector('[data-sort="' + sortValue + '"]');
            if (match) {
              match.classList.add("active");
              var aEl = match.querySelector("a");
              if (sortName && aEl) sortName.innerHTML = aEl.innerHTML;
            }
          }

          closeSortSheet();
        });
      });
    }

    function closeSortSheet() {
      if (sortSheet) sortSheet.classList.remove("open");
      document.documentElement.classList.remove("overflow-hidden");
    }

    /* ═══ Pills — actualizadas desde Liquid en cada AJAX response ═══ */
    function updatePills(newHtml) {
      var pillsEl = document.getElementById("unl-filter-pills");
      if (!pillsEl) return;
      var div = document.createElement("div");
      div.innerHTML = newHtml;
      var newPills = div.querySelector("#unl-filter-pills");
      if (newPills) {
        pillsEl.parentNode.replaceChild(newPills, pillsEl);
      } else {
        pillsEl.innerHTML = "";
      }
    }

    /* Apply button in sidebar */
    var applyBtn = container.querySelector(".unl-apply-btn");
    if (applyBtn) {
      applyBtn.addEventListener("click", closeSidebar);
    }

    /* ═══ AJAX Filter ═══ */
    function updateFilter() {
      var sectionEl = container.closest("[data-section-id]");
      var sectionId = container.dataset.sectionId || (sectionEl ? sectionEl.dataset.sectionId : "");
      if (!sectionId || !productGrid) return;

      var query = new URLSearchParams(new FormData(formFilter)).toString();
      var parts = [];
      var q = getParam("q");
      if (q) parts.push("q=" + q);
      parts.push("page=1");
      parts.push(query);
      var searchParams = parts.filter(Boolean).join("&");

      var url = window.location.pathname + "?" + searchParams + "&section_id=" + sectionId;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (htmlStr) {
          var div = document.createElement("div");
          div.innerHTML = htmlStr;

          var newGrid = div.querySelector(".main-collection-product-grid");
          if (newGrid) productGrid.innerHTML = newGrid.innerHTML;

          var newPagination = div.querySelector(".pagination-container");
          if (newPagination && paginationContainers.length) {
            var cleanHtml = newPagination.innerHTML.replace(/&view=ajax/g, "").replace(/&amp;view=ajax/g, "");
            for (var i = 0; i < paginationContainers.length; i++) {
              paginationContainers[i].innerHTML = cleanHtml;
            }
          }

          var newShowing = div.querySelector(".pagination-showing .showing");
          var currShowing = qsa(container, ".pagination-showing .showing");
          if (newShowing && currShowing.length) {
            for (var j = 0; j < currShowing.length; j++) {
              currShowing[j].innerHTML = newShowing.innerHTML;
            }
          }

          if (sidebarContainer) sidebarContainer.classList.add("active-ajax");

          initMaxlist(container);
          initPriceRange();
          updatePills(htmlStr);

          history.pushState({}, "", window.location.pathname + "?" + searchParams);
        })
        .catch(function (e) { /* silencioso para gama baja */ });
    }

    /* ═══ AJAX Sort ═══ */
    function updateSort(sortValue) {
      var sectionEl = container.closest("[data-section-id]");
      var sectionId = container.dataset.sectionId || (sectionEl ? sectionEl.dataset.sectionId : "");
      if (!sectionId || !productGrid) return;

      var params = new URLSearchParams();
      var q = getParam("q");
      if (q) params.set("q", q);
      params.set("sort_by", sortValue);
      params.set("page", "1");
      if (formFilter) {
        var fd = new FormData(formFilter);
        fd.forEach(function (value, key) {
          var existing = params.get(key);
          if (existing) params.set(key, existing + "," + value);
          else params.set(key, value);
        });
      }
      var searchParams = params.toString();
      var url = window.location.pathname + "?" + searchParams + "&section_id=" + sectionId;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (htmlStr) {
          var div = document.createElement("div");
          div.innerHTML = htmlStr;

          var newGrid = div.querySelector(".main-collection-product-grid");
          if (newGrid) productGrid.innerHTML = newGrid.innerHTML;

          var newPagination = div.querySelector(".pagination-container");
          if (newPagination && paginationContainers.length) {
            var cleanHtml = newPagination.innerHTML.replace(/&view=ajax/g, "").replace(/&amp;view=ajax/g, "");
            for (var i = 0; i < paginationContainers.length; i++) {
              paginationContainers[i].innerHTML = cleanHtml;
            }
          }

          var newShowing = div.querySelector(".pagination-showing .showing");
          var currShowing = qsa(container, ".pagination-showing .showing");
          if (newShowing && currShowing.length) {
            for (var j = 0; j < currShowing.length; j++) {
              currShowing[j].innerHTML = newShowing.innerHTML;
            }
          }

          history.pushState({}, "", window.location.pathname + "?" + searchParams);
        })
        .catch(function (e) { /* silencioso */ });
    }

    /* ═══ Price Range ═══ */
    function initPriceRange() {
      var parent = container.querySelector(".js-range-slider, .range-slider");
      if (!parent) return;

      var rangeS = qsa(parent, 'input[type="range"]');
      var numberS = qsa(parent, 'input[type="number"]');
      if (!rangeS.length || !numberS.length) return;

      rangeS.forEach(function (el) {
        el.oninput = function () {
          var s1 = parseFloat(rangeS[0].value);
          var s2 = parseFloat(rangeS[1].value);
          if (s1 > s2) { var tmp = s1; s1 = s2; s2 = tmp; }
          numberS[0].value = s1;
          numberS[1].value = s2;
        };
      });

      numberS.forEach(function (el) {
        el.oninput = function () {
          var n1 = parseFloat(numberS[0].value);
          var n2 = parseFloat(numberS[1].value);
          if (n1 > n2) {
            numberS[0].value = n2;
            numberS[1].value = n1;
          }
          rangeS[0].value = numberS[0].value;
          rangeS[1].value = numberS[1].value;
        };
      });

      var priceBtn = container.querySelector(".filter-price-button");
      if (priceBtn) {
        priceBtn.onclick = function () {
          var min = parent.querySelector(".field__input-min");
          var max = parent.querySelector(".field__input-max");
          var mainMin = container.querySelector(".main-range-slider .field__input-min");
          var mainMax = container.querySelector(".main-range-slider .field__input-max");
          if (mainMin && min) mainMin.value = min.value || "";
          if (mainMax && max) mainMax.value = max.value || "";
          var submit = container.querySelector(".filter-price-submit");
          if (submit) submit.click();
        };
      }
    }

    initPriceRange();
  }

  /* ═══ Show more/less ═══ */
  function initMaxlist(container) {
    qsa(container, ".maxlist-more").forEach(function (el) {
      el.onclick = function () {
        this.classList.add("d-none");
        var inner = this.closest(".filter-group_inner");
        if (inner) inner.classList.add("maxlist-more-active");
        var parent = this.closest(".filter-maxlist");
        var less = parent ? parent.querySelector(".maxlist-less") : null;
        if (less) less.classList.remove("d-none");
      };
    });

    qsa(container, ".maxlist-less").forEach(function (el) {
      el.onclick = function () {
        this.classList.add("d-none");
        var inner = this.closest(".filter-group_inner");
        if (inner) inner.classList.remove("maxlist-more-active");
        var parent = this.closest(".filter-maxlist");
        var more = parent ? parent.querySelector(".maxlist-more") : null;
        if (more) more.classList.remove("d-none");
      };
    });
  }

  function qsa(el, sel) {
    var nodes = el.querySelectorAll(sel);
    var arr = [];
    for (var i = 0; i < nodes.length; i++) arr.push(nodes[i]);
    return arr;
  }

  /* ═══ Boot ═══ */
  function boot() {
    var container =
      document.querySelector('[data-section-type="search-template"]') ||
      document.querySelector(".page-search");

    if (!container || !container.querySelector(".main-collection-product-grid")) return;

    var sectionEl = container.closest("[data-section-id]");
    var sectionId = container.dataset ? container.dataset.sectionId : null;
    if (!sectionId && sectionEl) {
      sectionId = sectionEl.dataset ? sectionEl.dataset.sectionId : null;
    }
    if (sectionId && container.dataset) container.dataset.sectionId = sectionId;

    init(container);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
